var path = 'scripts/views/directives/bca-dropdown.html';
var html = "<select class=\"form-control em-bold\"\n        id=\"bca-dropdown\"\n        ng-options='bca | bcaDisplayName group by bca.siteNumber for bca in bcas()'\n        ng-model=\"currentBca\"\n        ng-model-options=\"{getterSetter: true}\">\n</select>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/directives/bca-dropdown.html
// module id = 374
// module chunks = 0